import PaidIcon from "@mui/icons-material/Paid";
import { StudentServicePath } from "utils/constants";
import permissions from "app/permissions";
import DisciplinePricesList from "./List";

export const resources = {
  isMenu: true,
  icon: <PaidIcon />,
  name: `${StudentServicePath}curriculum-discipline-prices`,
  title: "Цени на дисциплини",
  custom: <DisciplinePricesList />,
  permission: permissions.canPreviewCurriculums,
};
